export default __webpack_public_path__ + "static/media/Coconut-Pastry.13fb2b79.jpg";